<template>
  <div class="loading">
    <div class="blockUI blockMsg blockPage">
      <div class="spinner"></div>
      <div class="spinner-text">Updating Results Please Wait ...</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
#results_section {
  position: relative;
  min-height: 460px;
}

.loading {
  cursor: wait;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.3);
}

.blockUI {
  position: fixed;
  padding: 50px;
  margin: 0px;
  top: 50%;
  left: 50%;
  text-align: center;
  color: rgb(0, 0, 0);
  border: none;
  background: url(/img/bg/sidebar_pattern.png) center top repeat;
  cursor: wait;
  border-radius: 5px;
}
</style>
